import '../base-react';
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './components/App';
const container = document.getElementById('content_wrap');
if (container) {
    const root = createRoot(container);
    root.render(React.createElement(App, null));
}
